import { render, staticRenderFns } from "./ArticlesOfAgreement.vue?vue&type=template&id=3bfbee6e&scoped=true"
import script from "./ArticlesOfAgreement.vue?vue&type=script&lang=js"
export * from "./ArticlesOfAgreement.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOfAgreement.vue?vue&type=style&index=0&id=3bfbee6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbee6e",
  null
  
)

export default component.exports